/**
 * Created by Ning Jiang on 2021-06-16.
 */

import {WinPresentationController} from "../WinPresentationController";
import {DeadwoodRip} from "../../DeadwoodRip";
import {DeadwoodRipSymbolState} from "../../symbol/DeadwoodRipSymbolConfig";

export class NoWinSymbolsController extends WinPresentationController {

    constructor() {
        super("NoWinSymbolsController", false);
    }

    protected hasWin():boolean {
        return (DeadwoodRip.model.parsedGameData.betWins?.length > 0 && DeadwoodRip.model.parsedGameData.singleWin > 0) || DeadwoodRip.model.parsedGameData.freespinTriggeredThisSpin;
    }

    protected async createWinAnimation():Promise<void> {
        const promises:Promise<any>[] = [];
        DeadwoodRip.model.parsedGameData.winPositions.forEach((reelWin, reelId) => {
            reelWin.forEach((w, symId) => {
                if(!w) {
                    promises.push(Promise.resolve(DeadwoodRip.reels[reelId].getSymbol(symId).getStateAnimation(
                        DeadwoodRipSymbolState.NO_WIN,
                        {duration : 0.1, alpha : 1},
                        {duration : 0.1, alpha : 0}
                    )));
                }
            });
        });

        await Promise.all(promises);
    }
}